export default __webpack_public_path__ + "static/media/caduceus-2.d075adcc.svg";